// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__9GPvw","footer_span":"footer_footer_span__V3u7U","author":"footer_author__e9EOP","footer_icon":"footer_footer_icon__BRkRY","pulse":"footer_pulse__xP9-u"};